import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent {
  currentDate:any;
  hospitalId:any;
  branches:any;
  isLoading: boolean = false;
  errors:any = '';
  selectedHospitalName: any;
  error: any;

  constructor(private route: ActivatedRoute, private spinner: NgxSpinnerService, private storage: StorageService,
    private apiService: ApiService, private snackBar: MatSnackBar, private router: Router) {
    this.currentDate = new Date();
  }

   // Api call for getting hospital according to selected hospital id
   getSelectedHospital(hospitalId: string) {
    this.apiService.getHospital(hospitalId).subscribe({
      next: (response: any) => {
         if (response.success === true) {
           this.selectedHospitalName = response.data.name;
           
         }
       },
       error: (err: any) => {
         // hiding spinner
         this.spinner.hide();
         this.snackBar.open(err.error.message, '', {
           duration: 2000,
           horizontalPosition: 'center',
           verticalPosition: 'top',
           panelClass: 'text-center'
         });
         this.error = err.error.message;
       },
       complete: () => {
         // hiding spinner
         this.spinner.hide();
       }
     });
  }

  ngOnInit() {
    this.spinner.show();
    this.route.params.subscribe(params => {
      this.hospitalId = params['hospitalId'];
      if(this.hospitalId)
      this.getbranchesList();
    });
    this.getSelectedHospital(this.hospitalId);
  }

  gotoDoctorsList(branch?: any) {
    if(branch){
     this.storage.set('selected-branch', JSON.stringify(branch));
     this.storage.set('selected-speciality', null);
    }else{
      this.storage.set('selected-branch', null);
      this.storage.set('selected-speciality', null);
    }
    this.router.navigate(['/doctors', { branchId: branch.id }]);
  }

  getbranchesList() {
    // showing spinner
    this.spinner.show();
    // Api call for getting doctors according to params
    this.apiService.getHospitalBranches(this.hospitalId).subscribe({
      next: (response: any) => {
        if (response.success === true) {        
          this.branches = response.data;
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.spinner.hide();
        this.isLoading = false; 
        this.snackBar.open(err.error.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.errors = err.error.message;
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
        this.isLoading = false; 
      }
    });
  }
}
